import { initializeAffiliateTracking } from '../../utils/affiliate';
import { useEffect } from 'react';

/**
 * Component that initializes affiliate tracking when the app loads
 * Should be placed in the main App component or router
 */
export const AffiliateTracker: React.FC = () => {
  useEffect(() => {
    // Initialize affiliate tracking on app load
    initializeAffiliateTracking().catch((error: unknown) => {
      console.error('Failed to initialize affiliate tracking:', error);
    });
  }, []);

  // This component doesn't render anything
  return null;
};
